var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 322,
    height: 33,
    viewBox: "0 0 322 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M308.686 3.85776L321.414 16.5857C322.195 17.3667 322.195 18.6331 321.414 19.4141L308.686 32.142C307.905 32.9231 306.639 32.9231 305.858 32.142C305.077 31.361 305.077 30.0947 305.858 29.3136L315.171 19.9999V15.9999L305.858 6.68619C305.077 5.90514 305.077 4.63881 305.858 3.85776C306.639 3.07671 307.905 3.07671 308.686 3.85776Z",
    fill: "#AA98FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M315.172 20H1.88066C0.841999 20 0 19.1046 0 18C0 16.8954 0.841999 16 1.88066 16H315.172V20Z",
    fill: "#AA98FE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.2261927d.svg";
export { ForwardRef as ReactComponent };